(() => {
  'use strict';

  const byId = (id) => document.getElementById(id);
  const angleCopy = {
    school: {
      kicker: 'Back-to-School routines · Made quieter',
      title: 'Own the morning.<br>Own the semester.',
      accent: 'Wake on time—without the household alarm.',
      body: 'A silent vibration on the wrist helps students build an independent routine without waking siblings, roommates, or the whole house.',
      cta: 'Choose your WRISTLY'
    },
    access: {
      kicker: 'Designed for independent mornings',
      title: 'Your alarm should<br>speak your language.',
      accent: 'A clear vibration. No sound required.',
      body: 'WRISTLY puts the wake-up signal directly on your wrist—giving Deaf and hard-of-hearing sleepers more control over when the day begins.',
      cta: 'Find your WRISTLY'
    },
    sleepers: {
      kicker: 'For deep sleepers and quiet homes',
      title: 'Wake reliably.<br>Leave the noise behind.',
      accent: 'Strong on your wrist. Silent in the room.',
      body: 'Set your time, wear it to sleep, and feel the alarm where it matters. Your partner keeps sleeping. You start the day calm and on time.',
      cta: 'Choose your model'
    }
  };

  const heroKicker = byId('heroKicker');
  const heroTitle = byId('heroTitle');
  const heroAccent = byId('heroAccent');
  const heroBody = byId('heroBody');
  const heroCta = byId('heroCta');
  const modelSelect = byId('modelSelect');
  const mobileModel = byId('mobileModel');
  const mobilePrice = byId('mobilePrice');
  const mobileBuyLink = byId('mobileBuyLink');

  document.querySelectorAll('[data-angle]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-angle]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('active', active);
        item.setAttribute('aria-selected', String(active));
      });
      const copy = angleCopy[button.dataset.angle];
      if (!copy) return;
      heroKicker.textContent = copy.kicker;
      heroTitle.innerHTML = copy.title;
      heroAccent.textContent = copy.accent;
      heroBody.textContent = copy.body;
      heroCta.innerHTML = `${copy.cta} <span>→</span>`;
    });
  });

  const cards = Array.from(document.querySelectorAll('[data-model]'));
  const chooseModel = (id, scroll = true) => {
    const card = cards.find((item) => item.dataset.model === id);
    if (!card) return;
    cards.forEach((item) => item.classList.toggle('selected', item === card));
    if (modelSelect) modelSelect.value = id;
    if (mobileModel) mobileModel.textContent = card.dataset.name || '';
    if (mobilePrice) mobilePrice.textContent = card.dataset.price || '';
    if (mobileBuyLink) {
      mobileBuyLink.href = card.dataset.url || '#models';
      mobileBuyLink.textContent = `Choose ${(card.dataset.name || 'WRISTLY').replace('WRISTLY ', '')}`;
    }
    if (scroll) byId('models')?.scrollIntoView({ behavior: 'smooth' });
  };

  modelSelect?.addEventListener('change', (event) => chooseModel(event.target.value));
  cards.forEach((card) => {
    card.addEventListener('click', (event) => {
      if (event.target.closest('a,button,select')) return;
      chooseModel(card.dataset.model, false);
    });
  });

  byId('pulseButton')?.addEventListener('click', () => {
    const demo = byId('pulseDemo');
    const state = byId('pulseState');
    demo?.classList.add('is-pulsing');
    if (state) state.textContent = 'VIBRATING';
    window.setTimeout(() => {
      demo?.classList.remove('is-pulsing');
      if (state) state.textContent = 'SILENT';
    }, 3600);
  });

  document.querySelectorAll('.faq-list article button').forEach((button) => {
    button.addEventListener('click', () => {
      const article = button.closest('article');
      const opening = !article.classList.contains('open');
      article.classList.toggle('open', opening);
      button.setAttribute('aria-expanded', String(opening));
      const marker = button.querySelector('b');
      if (marker) marker.textContent = opening ? '−' : '+';
    });
  });
})();
